import * as types from './window-actiontypes';

export const windowResize = (sizeType) => ({
  type: types.WINDOW_RESIZE,
  size: sizeType,
});
